import { CButton, CModal } from '@coreui/react'
import { motion } from 'framer-motion'
import React, { useEffect, useState } from 'react'
import { ChevronDown, ChevronsUpDown, Pencil, Signature, X } from 'lucide-react'
import QuestionTextInputFormBuilder from './QuestionTextInputFormBuilder'
import QuestionDropdownBuilder from './QuestionDropdownBuilder'

const ModalFormBuilder = ({
  mode,
  isOpen,
  onClose,
  setIsOpenModal,
  setAllQuestions,
  allQuestions,
  selectedEditDiagnosisQuestion,
  selectedEditDiagnosisQuestionIndex,
  fetchedQuestions,
  setFetchedQuestions,
  newQuestions,
  setNewQuestions,
  setSelectedEditDiagnosisQuestion,
  addFormMade,
  setCallAddFromMade,
  diagnosisData,
  selectedDiagnosis,
  setQuestionType,
  questionType,
}) => {
  const [currentTextInputs, setCurrentTextInputs] = useState({
    id: Date.now(),
    label: '',
    answer: '',
    isTextArea: true,
    isTextInputText: false,
    toolTipValue: '',
    isPretextToShow: false,
    type: 'input',
    preText: '',
    postText: '',
    isRemark: '',
    remarkToShow: false,
    isPostTextToShow: false,
    isValueShowInAssessment: false,
    condition: null,
    historyOfDiagnosis: false,
  })

  const [dropdownInput, setDropdownInput] = useState({
    id: Date.now(),
    label: '',
    answer: '',
    condition: null,
    type: 'dropdown',
    isMultiple: false,
    toolTipValue: '',
    options: [],
    freeType: '',
    showFreeTypeInAssessment: false,
  })

  useEffect(() => {
    if (selectedEditDiagnosisQuestion) {
      setQuestionType(selectedEditDiagnosisQuestion.type)
      if (selectedEditDiagnosisQuestion.type === 'input') {
        setCurrentTextInputs(selectedEditDiagnosisQuestion)
      } else {
        setDropdownInput(selectedEditDiagnosisQuestion)
      }
    }
  }, [selectedEditDiagnosisQuestion])

  const saveQuestion = (questionObj, shouldModelCall = true) => {
    // if (shouldModelCall) {
    //   setIsOpenModal(false);
    // }
    setIsOpenModal(false)
    setDropdownInput(questionObj)
    addQuestions('dropdown', questionObj)

    setCallAddFromMade(true)
  }

  const addQuestions = async (type, questionObj = {}) => {
    if (selectedEditDiagnosisQuestion) {
      if (type === 'input') {
        let updatedQuestions = [...fetchedQuestions.questionData]
        updatedQuestions[selectedEditDiagnosisQuestionIndex] = currentTextInputs
        setFetchedQuestions((p) => ({
          ...p,
          questionData: updatedQuestions,
        }))
        resetInputState()
      } else {
        let updatedQuestions = [...fetchedQuestions.questionData]
        updatedQuestions[selectedEditDiagnosisQuestionIndex] = questionObj
        setFetchedQuestions((p) => ({
          ...p,
          questionData: updatedQuestions,
        }))
        resetDropdownState()
      }
    } else {
      if (type === 'input') {
        setAllQuestions((p) => [...p, currentTextInputs])
        resetInputState()
      } else {
        setAllQuestions((p) => [...p, questionObj])
        resetDropdownState()
      }
    }
  }

  const resetInputState = () => {
    setCurrentTextInputs({
      id: Date.now(),
      label: '',
      answer: '',
      isTextArea: true,
      isTextInputText: false,
      toolTipValue: '',
      isPretextToShow: false,
      type: 'input',
      preText: '',
      postText: '',
      isRemark: '',
      remarkToShow: false,
      isPostTextToShow: false,
      isValueShowInAssessment: false,
      condition: null,
      historyOfDiagnosis: false,
    })
    setQuestionType('')
    // setIsOpenModal(false);
  }

  const resetDropdownState = () => {
    setDropdownInput({
      id: Date.now(),
      label: '',
      answer: '',
      condition: null,
      type: 'dropdown',
      isMultiple: false,
      toolTipValue: '',
      options: [],
    })
    setQuestionType('dropdown')
    setSelectedEditDiagnosisQuestion(null)
  }
  //   mode,
  //   allQuestions,
  //   selectedEditDiagnosisQuestion,
  //   selectedEditDiagnosisQuestionIndex,
  //   fetchedQuestions,
  //   setIsOpenModal,
  //   dropdownInput,
  //   setDropdownInput,
  //   addQuestions,
  //   setSelectedEditDiagnosisQuestion,
  //   setCallAddFromMade,
  //   diagnosisData,
  //   selectedDiagnosis,
  // });

  return (
    <motion.div className={`custom-form-builder-theme__modal-backdrop w-100 top-0 left-0 position-fixed d-flex align-items-center justify-content-center ${isOpen ? 'visible' : 'invisible'}`} style={{ inset: 0, height: '100vh' }}>
      {!questionType && (
        <motion.div className="custom-form-builder-theme__type-picker shadow-lg" style={{ width: '40%', height: '40%', borderRadius: '40px' }}>
          <div className="d-flex align-items-center justify-content-center flex-column w-100 h-100">
            <p className="font-weight-bold fs-5 mb-3">Select Question Type</p>
            <div className="d-flex align-items-center justify-content-center gap-3">
              {/* Text Input Card */}
              <span
                onClick={() => {
                  resetInputState()
                  setQuestionType('input')
                }}
                style={{
                  width: '150px',
                  height: '150px',
                  borderRadius: '12px',
                  cursor: 'pointer',
                  background: '#4c8bf5',
                  transition: 'all 0.2s ease-in-out',
                  boxShadow: questionType === 'input' ? '0 6px 15px rgba(76, 139, 245, 0.4)' : '0 3px 10px rgba(0, 0, 0, 0.1)',
                  transform: questionType === 'input' ? 'scale(1.03)' : 'scale(1)',
                }}
                className={`d-flex text-white flex-column shadow justify-content-center align-items-center p-2 ${questionType === 'input' ? 'border border-primary' : ''}`}
              >
                <Pencil className="fs-3" />
                <p className="font-weight-semibold fs-6 p-0 m-0">Freetype</p>
              </span>

              {/* Dropdown Card */}
              <span
                onClick={() => {
                  resetDropdownState()
                }}
                style={{
                  width: '150px',
                  height: '150px',
                  borderRadius: '12px',
                  cursor: 'pointer',
                  background: '#4c8bf5',
                  transition: 'all 0.2s ease-in-out',
                  boxShadow: questionType === 'dropdown' ? '0 6px 15px rgba(92, 184, 92, 0.4)' : '0 3px 10px rgba(0, 0, 0, 0.1)',
                  transform: questionType === 'dropdown' ? 'scale(1.03)' : 'scale(1)',
                }}
                className={`d-flex text-white flex-column shadow justify-content-center align-items-center p-2 ${questionType === 'dropdown' ? 'border border-primary' : ''}`}
              >
                <span className="border border-white d-flex align-items-center justify-content-end rounded" style={{ width: '80px', height: '25px' }}>
                  <ChevronDown className="fs-5 align-middle" />
                </span>
                <p className="font-weight-semibold fs-6 p-0 m-0">Options</p>
              </span>
            </div>
            <CButton
              color="secondary"
              className="mt-3 px-4 ui-action-btn ui-action-btn--secondary"
              onClick={onClose}
            >
              Close
            </CButton>
          </div>
        </motion.div>
      )}
      {questionType && questionType === 'input' && (
        <QuestionTextInputFormBuilder
          allQuestions={allQuestions}
          selectedEditDiagnosisQuestion={selectedEditDiagnosisQuestion}
          selectedEditDiagnosisQuestionIndex={selectedEditDiagnosisQuestionIndex}
          setIsOpenModal={setIsOpenModal}
          setQuestionType={setQuestionType}
          addQuestions={addQuestions}
          setCurrentTextInputs={setCurrentTextInputs}
          currentTextInputs={currentTextInputs}
          setCallAddFromMade={setCallAddFromMade}
          dropdownInput={dropdownInput}
          setDropdownInput={setDropdownInput}
          fetchedQuestions={fetchedQuestions}
        />
      )}
      {questionType && questionType === 'dropdown' && (
        <QuestionDropdownBuilder
          mode={mode.current}
          allQuestions={allQuestions}
          selectedEditDiagnosisQuestion={selectedEditDiagnosisQuestion}
          fetchedQuestions={fetchedQuestions}
          setIsOpenModal={setIsOpenModal}
          dropdownInput={dropdownInput}
          setDropdownInput={setDropdownInput}
          addQuestions={addQuestions}
          setSelectedEditDiagnosisQuestion={setSelectedEditDiagnosisQuestion}
          setCallAddFromMade={setCallAddFromMade}
          diagnosisData={diagnosisData}
          selectedDiagnosis={selectedDiagnosis}
          saveQuestion={saveQuestion}
          currentTextInputs={currentTextInputs}
          setCurrentTextInputs={setCurrentTextInputs}
          addFormMade={addFormMade}
        />
      )}
    </motion.div>
  )
}

export default ModalFormBuilder
